import { MessageLog } from '../components/MessageLog';


export const Messages = () => {

  return (
    <>
      <MessageLog/>
    </>
  );
};